/*
  mv-collection.js — client behaviour for sections/mv-collection.liquid
  ---------------------------------------------------------------------
  Externalised verbatim from the section's former inline <script>. Loaded
  via `<script src="{{ 'mv-collection.js' | asset_url }}" defer>` at the end
  of the section. As a classic (non-module) deferred script, the top-level
  function declarations below are global (window.*), so the inline
  onclick/oninput/onchange handlers in the markup resolve them. The six
  handler-referenced functions are also re-exported on `window` explicitly at
  the bottom to make that contract self-documenting.

  Data contract: this script reads only DOM state / data-* attributes already
  present in the markup (#mvcGrid[data-fallback|data-pages], #mvcCount[
  data-total|data-showing|data-of|data-results], .mvc-item[data-price|
  data-available], and window.location). No Liquid values are injected, so no
  config block is required.
*/
function mvcOpenF(){document.getElementById('mvcFilters').classList.add('open');document.getElementById('mvcBackdrop').classList.add('show');document.body.style.overflow='hidden';}
function mvcCloseF(){document.getElementById('mvcFilters').classList.remove('open');document.getElementById('mvcBackdrop').classList.remove('show');document.body.style.overflow='';}
function mvcSort(v){var u=new URL(window.location.href);u.searchParams.set('sort_by',v);u.searchParams.delete('page');window.location.href=u.toString();}

// Client-side price + in-stock filter over the rendered grid (fallback mode
// only; the primary refinement path is the server-side facets/tags).
//
// The grid initially renders only the current paginated page. Filtering a
// single page would silently return partial results for multi-page
// collections, so before applying any filter we lazily fetch every remaining
// page over the network, splice its .mvc-item nodes into the grid, and only
// then filter across the COMPLETE collection. The result count updates to
// reflect what is actually visible.
var mvcFullLoaded=false, mvcLoading=false;

function mvcActiveFilters(){
  var minEl=document.getElementById('mvcPriceMin');
  var maxEl=document.getElementById('mvcPriceMax');
  var min=minEl&&minEl.value!==''?parseFloat(minEl.value)*100:null;
  var max=maxEl&&maxEl.value!==''?parseFloat(maxEl.value)*100:null;
  var stockOpt=document.getElementById('mvcInStockOpt');
  var stockBar=document.getElementById('mvcStockToggle');
  var inStock=(stockOpt&&stockOpt.classList.contains('on'))||(stockBar&&stockBar.classList.contains('on'));
  return {min:min,max:max,inStock:inStock,any:(min!==null||max!==null||inStock)};
}

function mvcUpdateCount(){
  var c=document.getElementById('mvcCount');
  if(!c)return;
  var items=document.querySelectorAll('#mvcGrid .mvc-item');
  if(!items.length)return;
  var visible=0;
  items.forEach(function(it){if(it.style.display!=='none')visible++;});
  var f=mvcActiveFilters();
  var total=parseInt(c.getAttribute('data-total'),10)||items.length;
  if(f.any&&mvcFullLoaded){
    // Filter active AND every page loaded: matches are counted across the
    // WHOLE collection, so both numbers share the same (full) scope.
    c.innerHTML=c.getAttribute('data-showing')+' <b>'+visible+'</b> '+c.getAttribute('data-of')+' <b>'+total+'</b> '+c.getAttribute('data-results');
  }else if(f.any){
    // Filter active but still loading remaining pages: showing a current-page
    // match tally against the full total would be misleading, so leave the
    // server-rendered count in place until the full set arrives.
    return;
  }else if(mvcFullLoaded){
    // Filters cleared after loading everything: show the full set.
    c.innerHTML=c.getAttribute('data-showing')+' <b>'+total+'</b> '+c.getAttribute('data-of')+' <b>'+total+'</b> '+c.getAttribute('data-results');
  }
}

function mvcApply(){
  var f=mvcActiveFilters();
  document.querySelectorAll('#mvcGrid .mvc-item').forEach(function(it){
    var price=parseInt(it.getAttribute('data-price'),10);
    var avail=it.getAttribute('data-available')==='true';
    var ok=true;
    if(f.min!==null&&!isNaN(price)&&price<f.min)ok=false;
    if(f.max!==null&&!isNaN(price)&&price>f.max)ok=false;
    if(f.inStock&&!avail)ok=false;
    it.style.display=ok?'':'none';
  });
  mvcUpdateCount();
}

// Fetch pages 2..N of the current collection view and append their items.
function mvcLoadAll(cb){
  var grid=document.getElementById('mvcGrid');
  if(!grid||grid.getAttribute('data-fallback')!=='true'){mvcFullLoaded=true;return cb();}
  if(mvcFullLoaded)return cb();
  if(mvcLoading)return; // a load is already in flight; it will re-apply on finish
  var pages=parseInt(grid.getAttribute('data-pages'),10)||1;
  if(pages<=1){mvcFullLoaded=true;return cb();}
  mvcLoading=true;
  var reqs=[];
  for(var p=2;p<=pages;p++){
    var u=new URL(window.location.href);
    u.searchParams.set('page',p);
    reqs.push(fetch(u.toString(),{headers:{'X-Requested-With':'XMLHttpRequest'}})
      .then(function(r){return r.ok?r.text():'';})
      .then(function(html){
        if(!html)return document.createDocumentFragment();
        var doc=new DOMParser().parseFromString(html,'text/html');
        var frag=document.createDocumentFragment();
        doc.querySelectorAll('#mvcGrid .mvc-item').forEach(function(n){frag.appendChild(document.importNode(n,true));});
        return frag;
      }).catch(function(){return document.createDocumentFragment();}));
  }
  Promise.all(reqs).then(function(frags){
    frags.forEach(function(frag){grid.appendChild(frag);});
    mvcFullLoaded=true;mvcLoading=false;
    var pager=document.getElementById('mvcPager');if(pager)pager.style.display='none';
    cb();
  });
}

function mvcClientFilter(){
  var f=mvcActiveFilters();
  if(f.any&&!mvcFullLoaded){
    // Load the whole collection first, then filter across all of it.
    mvcLoadAll(function(){mvcApply();});
    // Apply immediately over what's rendered so the UI is responsive;
    // mvcApply() re-runs once the full set arrives.
    mvcApply();
    return;
  }
  if(!f.any){
    // No filters: restore native pagination + server count.
    var pager=document.getElementById('mvcPager');
    if(pager&&!mvcFullLoaded)pager.style.display='';
  }
  mvcApply();
}
// Sidebar "In stock only" checkbox and the toolbar toggle stay in sync.
function mvcSyncPressed(el){if(el&&el.hasAttribute('aria-pressed'))el.setAttribute('aria-pressed',el.classList.contains('on')?'true':'false');}
function mvcToggleStock(el){el.classList.toggle('on');mvcSyncPressed(el);var b=document.getElementById('mvcStockToggle');if(b){b.classList.toggle('on',el.classList.contains('on'));mvcSyncPressed(b);}mvcClientFilter();}
function mvcToggleStockBar(el){el.classList.toggle('on');mvcSyncPressed(el);var o=document.getElementById('mvcInStockOpt');if(o){o.classList.toggle('on',el.classList.contains('on'));mvcSyncPressed(o);}mvcClientFilter();}

// Explicit global exports for the inline on* handlers in the markup.
window.mvcOpenF=mvcOpenF;
window.mvcCloseF=mvcCloseF;
window.mvcSort=mvcSort;
window.mvcClientFilter=mvcClientFilter;
window.mvcToggleStock=mvcToggleStock;
window.mvcToggleStockBar=mvcToggleStockBar;
